export default {
  HOST: '//ben-melech.com',
  // HOST: '//127.0.0.1:8082',
  GA_TRACKING_ID: 'UA-109217691-2'
};
